import SanityClientConstructor, { SanityClient } from "@sanity/client";
import ImageUrlBuilder from "@sanity/image-url";
import { HomePage, Project } from "./types";

// Define a type for your gallery image, if not already defined in types.ts
// You might want to add this to your types.ts file for better type safety
export type GalleryImage = {
  url: string;
  alt?: string;
};

class Sanity {
  static instance: Sanity = new Sanity();

  private client: SanityClient;

  constructor() {
    this.client = SanityClientConstructor({
      projectId: process.env.REACT_APP_SANITY_PROJECTID!,
      dataset: process.env.REACT_APP_SANITY_DATASET || "",
      token: process.env.REACT_APP_SANITY_TOKEN || "",
      useCdn: false,
      apiVersion: "2021-03-25",
    });
  }

  imageUrlBuilder = (source: string) =>
    ImageUrlBuilder(this.client).image(source);

  getProjects = async (): Promise<Project[]> => {
    return await this.client.fetch(
      '*[_type == "project"] { ..., "vegetation": vegetation.asset->url , floors[]{ ..., floor{ ..., "document": document.asset->url, flats[]{ ..., flat{ ..., type->{...}, "document": document.asset->url } } } } }'
    );
  };

  getHomePage = async (): Promise<HomePage> => {
    return await this.client.fetch('*[_type == "homePage"]').then((a) => a[0]);
  };

  createContact = async (data: {
    fullName: string;
    email: string;
    mobileNumber: string;
    message: string;
  }) => {
    try {
      const response = await this.client.create({
        _type: "contact",
        ...data,
      });
      console.log("Document created:", response);
    } catch (error) {
      console.error("Failed to create contact:", error);
    }
  };

  // New method to fetch gallery images
  getGalleryImages = async (): Promise<GalleryImage[]> => {
    const query = `*[_type == "gallery"][0] {
      images[]{
        "url": asset->url,
        "alt": alt,
      }
    }.images`; // Added .images to directly get the array of images
    const data = await this.client.fetch(query);
    return data;
  };
}

export default Sanity.instance;
